import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IonModal } from '@ionic/angular';
import { ManifestsRepository } from '@shared/state/manifests';
import { ReservationsRepository } from '@shared/state/reservations/reservation.repository';

@Component({
	selector: 'qr-code',
	templateUrl: 'qr-code.component.html',
})
export class QrCodeComponent implements OnInit {
	@Input('productId') productId: number;
	@Input('isManifest') isManifest: boolean = false;
	@Output() willDismiss = new EventEmitter<void>();
	@ViewChild('qrModalRef') qrModal: IonModal;
	public productName: string;
	public reservationId: number;

	constructor(
		private readonly manifestsRepo: ManifestsRepository,
		private readonly reservationsRepo: ReservationsRepository
	) {}

	ngOnInit() {
		if (this.isManifest) this.manifestSetup();
	}

	public configure({ productId, productName, reservationId }) {
		this.productId = productId;
		this.productName = productName;
		this.reservationId = reservationId;
		this.present();
	}

	public present() {
		this.qrModal.present();
	}

	public dismissModal() {
		this.willDismiss.emit();
		this.qrModal.dismiss();
	}

	private manifestSetup() {
		const { reservationId } = this.manifestsRepo.getActiveManifest();
		const { name } = this.reservationsRepo.activeReservation(reservationId);
		this.productName = name;
		this.reservationId = reservationId;
	}
}
